import BaseResource from './BaseResource'

export default class Items extends BaseResource {
  static endpoint = '/api/v1/items' ///tracking
}
